import { useState } from "react";
import "./styles/SideBar.css";
import { permisos_codigo_id } from "../components/generales/GroupsId";
import { lang } from "./generales/traduction";
import { capitalizeFirstLetter } from "../utils/utils";

const SideBar = ({
  mode,
  userPermissions,
  rolId,
  onLogin,
  pageSelected,
  setPageSelected,
  dataGlobals,
  languaje
}) => {
  const [pageDesplegado,setPageDesplegado]=useState('')
  const [subPageDesplegado,setSubPageDesplegado]=useState('')
  //  console.log(subPageDesplegado)
  const handleSection = (e) => {
    // console.log(e.target.attributes.name.value)
    if(e.target.attributes.name.value!="config" && e.target.attributes.name.value!="admin" && e.target.attributes.name.value!="reportes" && e.target.attributes.name.value!="mantenimiento"
      && e.target.attributes.name.value!="respaldo" && e.target.attributes.name.value!="encuestas" && e.target.attributes.name.value!="workflow"
    ){
      if(e.target.attributes.name.value!="config-medDif"){
       
        setPageSelected(e.target.attributes.name.value);
      }else{
       
        if(subPageDesplegado==e.target.attributes.name.value){
          
          setSubPageDesplegado('')
        }else{
          
          setSubPageDesplegado(e.target.attributes.name.value)
          setPageSelected(e.target.attributes.name.value);
        }
      }
      
    }else{
     
      setSubPageDesplegado('')
      if(pageDesplegado==e.target.attributes.name.value){
        setPageDesplegado('')
      }else{
        setPageDesplegado(e.target.attributes.name.value)
      }
      
    }
    
  };
  const handleSubSection = (e) => {
    // console.log(e.target.attributes.name.value)
    if(e.target.attributes.name.value!="config" && e.target.attributes.name.value!="admin" && e.target.attributes.name.value!="reportes" && e.target.attributes.name.value!="mantenimiento"
      && e.target.attributes.name.value!="respaldo" && e.target.attributes.name.value!="encuestas" && e.target.attributes.name.value!="workflow"
    ){
      setSubPageDesplegado(e.target.attributes.name.value);
    }else{
      if(pageDesplegado==e.target.attributes.name.value){
        setSubPageDesplegado('')
      }else{
        setSubPageDesplegado(e.target.attributes.name.value)
      }
      
    }
    
  };
  var estado = "";
  var reportes = 0;
  var cis = 0;
  var acciones = 0;
  var hosts = 0;
  var buzon = 0;
  var portafolio = 0;
  var mantenimiento = 0;
  var configuracion = 0;

  if (dataGlobals.data.data !== undefined) {
  
    estado = dataGlobals.data.data.find((obj) => obj.name === "estado");
    reportes = dataGlobals.data.data.find(
      (obj) => obj.name === "report_module"
    );
    cis = dataGlobals.data.data.find((obj) => obj.name === "ci_module");
   
    acciones = dataGlobals.data.data.find(
      (obj) => obj.name === "action_module"
    );
    hosts = 0;
    buzon = dataGlobals.data.data.find((obj) => obj.name === "mail_module");
    
    configuracion=dataGlobals.data.data.find((obj) => obj.name === "config_module");
    mantenimiento=dataGlobals.data.data.find((obj) => obj.name === "matto_module");
    portafolio=dataGlobals.data.data.find((obj) => obj.name === "portafolio_module");
  }

  return (
    <div className={"sidebar" + mode}>
      {dataGlobals.loading || dataGlobals.error ? (
       ""
     ) : (
     <>
       <div className="sidebarHeader">
       <div
           className={
             "sidebarRow " +
             (pageSelected === "inicio" ? "sideRowSelected" + mode : "")
           }
           style={{height:'100%'}}
         >
           <div
             className={
               "sidebarCont" +
               mode +
               " " +
               (pageSelected === "inicio" ? "sideSelected" + mode : "")
             }
             name="inicio"
             onClick={handleSection}
           >
             <div className="imgSideCont" name="inicio">
               <img
                 src={
                   "/iconos/perfil-blanco.png" 
                 }
                 name="inicio"
               />
             </div>
             <div className="textSideCont" name="inicio">
             {capitalizeFirstLetter(lang[languaje]['inicio'])}
             </div>
           </div>
         </div>
       </div>
       <div className="sidebarBody">

       <>
        
         {
         userPermissions.some(
           (objeto) => objeto.permission_id === permisos_codigo_id["monitor"]
         ) 
         ? (
           <div
             className={
               "sidebarRow " +
               (pageSelected === "monitoreo" ? "sideRowSelected" + mode : "")
             }
           >
             <div
               className={
                 "sidebarCont" +
                 mode +
                 " " +
                 (pageSelected === "monitoreo" ? "sideSelected" + mode : "")
               }
               name="monitoreo"
               onClick={handleSection}
             >
               <div className="imgSideCont" name="monitoreo">
                 <img
                  src={
                   "/iconos/monitoreo-blanco.png"
                 }
                   // src={
                   //   "/iconos/monitoreo" +
                   //   (pageSelected === "monitoreo"
                   //     ? mode == ""
                   //       ? "-blanco.png"
                   //       : ".png"
                   //     : mode != ""
                   //     ? "-blanco.png"
                   //     : ".png")
                   // }
                   name="monitoreo"
                 />
                
               </div>
               <div className="textSideCont " name="monitoreo">
               {capitalizeFirstLetter(lang[languaje]['monitoreo'])}
               </div>
             </div>
           </div>
         ) : (
           ""
         )}

         {
         userPermissions.some(
           (objeto) => objeto.permission_id === permisos_codigo_id["admin"]
         ) 
          ? (
           (<>
             <div
               className={
                 "sidebarRow " +
                 (pageDesplegado === "admin" ? "sideRowSelected" + mode : "")
               }
             >
               <div
                 className={
                   "sidebarCont" +
                   mode +
                   " " +
                   (pageDesplegado === "admin" ? "sideSelected" + mode : "")
                 }
                 name="admin"
                 onClick={handleSection}
               >
                 <div className="imgSideCont" name="admin">
                   <img
                     src={
                       "/iconos/panel-admin-blanco.png" 
                       
                     }
                     name="admin"
                   />
                 </div>
                 <div className="textSideCont " name="admin">
                 {capitalizeFirstLetter(lang[languaje]['admin'])}
                 </div>
               </div>
               <div className="contArrowSelected">
               <img
                     src={
                       "/iconos/"+((pageDesplegado === "admin")?"down-arrow-select.png":"up-arrow-select.png") 
                       
                     }
                     name="admin"
                   />
               </div>
             </div>
             { pageDesplegado === "admin" && <div className="sidebarRow desplegado">
              <div className="sidebarRowsub ">
              <div
                  className={
                    "sidebarCont" +
                    mode +
                    " " +
                    (pageSelected === "admin-users" ? "sideSelected" + mode : "")
                  }
                  name="admin-users"
                  onClick={handleSection}
                >
                  
                  <div className="textSideCont " name="admin-users" style={{fontSize:'var(--font-size-xSmall)',width:'90%',left: '10%',position: 'relative'}}>
                  {capitalizeFirstLetter(lang[languaje]['usuarios'])}
                  </div>
                </div>
              </div>
              <div className="sidebarRowsub ">
              <div
                  className={
                    "sidebarCont" +
                    mode +
                    " " +
                    (pageSelected === "admin-rol" ? "sideSelected" + mode : "")
                  }
                  name="admin-rol"
                  onClick={handleSection}
                >
                  
                  <div className="textSideCont " name="admin-rol" style={{fontSize:'var(--font-size-xSmall)',width:'90%',left: '10%',position: 'relative'}}>
                  {'Roles'}
                  </div>
                </div>
              </div>
              <div className="sidebarRowsub ">
              <div
                  className={
                    "sidebarCont" +
                    mode +
                    " " +
                    (pageSelected === "admin-grupos" ? "sideSelected" + mode : "")
                  }
                  name="admin-grupos"
                  onClick={handleSection}
                >
                  
                  <div className="textSideCont " name="admin-grupos" style={{fontSize:'var(--font-size-xSmall)',width:'90%',left: '10%',position: 'relative'}}>
                  {capitalizeFirstLetter(lang[languaje]['gruposUsuarios'])}
                  </div>
                </div>
              </div>
              <div className="sidebarRowsub ">
              <div
                  className={
                    "sidebarCont" +
                    mode +
                    " " +
                    (pageSelected === "noti-user" ? "sideSelected" + mode : "")
                  }
                  name="noti-user"
                  onClick={handleSection}
                >
                  
                  <div className="textSideCont " name="noti-user" style={{fontSize:'var(--font-size-xSmall)',width:'90%',left: '10%',position: 'relative'}}>
                  {capitalizeFirstLetter(lang[languaje]['NotiUsuarios'])}
                  </div>
                </div>
              </div>
            </div>}
           </>)
           // <div
           //   className={
           //     "sidebarRow " +
           //     (pageSelected === "panel-admin" ? "sideRowSelected" + mode : "")
           //   }
           // >
           //   <div
           //     className={
           //       "sidebarCont" +
           //       mode +
           //       " " +
           //       (pageSelected === "panel-admin" ? "sideSelected" + mode : "")
           //     }
           //     name="panel-admin"
           //     onClick={handleSection}
           //   >
           //     <div className="imgSideCont" name="panel-admin">
           //       <img
           //        src={
           //         "/iconos/panel-admin-blanco.png" 
           //       }
           //         // src={
           //         //   "/iconos/panel-admin" +
           //         //   (pageSelected === "panel-admin"
           //         //     ? mode == ""
           //         //       ? "-blanco.png"
           //         //       : ".png"
           //         //     : mode != ""
           //         //     ? "-blanco.png"
           //         //     : ".png")
           //         // }
           //         name="panel-admin"
           //       />
           //     </div>
           //     <div className="textSideCont " name="panel-admin">
           //     {capitalizeFirstLetter(lang[languaje]['admin'])}
           //     </div>
           //     <div className="contArrowSelected">
           //   <img
           //         src={
           //           "/iconos/"+((pageDesplegado === "admin")?"down-arrow-select.png":"up-arrow-select.png") 
                     
           //         }
           //         name="admin"
           //       />
           //   </div>
           //   </div>
           // </div>
           
         ) : (
           ""
         )}
         {cis.value == 1 &&
         userPermissions.some(
           (objeto) => objeto.permission_id === permisos_codigo_id["cis"]
         ) ? (
           <div
             className={
               "sidebarRow " +
               (pageSelected === "cis" ? "sideRowSelected" + mode : "")
             }
           >
             <div
               className={
                 "sidebarCont" +
                 mode +
                 " " +
                 (pageSelected === "cis" ? "sideSelected" + mode : "")
               }
               name="cis"
               onClick={handleSection}
             >
               <div className="imgSideCont" name="cis">
                 <img
                   src={
                     "/iconos/cis-blanco.png"
                   }
                   name="cis"
                 />
               </div>
               <div className="textSideCont " name="cis">
               {lang[languaje]['cis'].toUpperCase()}
               </div>
             </div>
           </div>
         ) : (
           ""
         )}
         {portafolio.value == 1  &&
         userPermissions.some(
           (objeto) =>
             objeto.permission_id === permisos_codigo_id["portafolio"]
         ) ? (
           <div
             className={
               "sidebarRow " +
               (pageSelected === "portafolio" ? "sideRowSelected" + mode : "")
             }
           >
             <div
               className={
                 "sidebarCont" +
                 mode +
                 " " +
                 (pageSelected === "portafolio" ? "sideSelected" + mode : "")
               }
               name="portafolio"
               onClick={handleSection}
             >
               <div className="imgSideCont" name="portafolio">
                 <img
                   src={
                     "/iconos/portafolio-blanco.png" 
                   }
                   name="portafolio"
                 />
               </div>
               <div className="textSideCont" name="portafolio">
               {capitalizeFirstLetter(lang[languaje]['portafolio'])}
               </div>
             </div>
           </div>
         ) : (
           ""
         )}
         {mantenimiento.value == 1  &&
         userPermissions.some(
           (objeto) =>
             objeto.permission_id === permisos_codigo_id["mantenimiento"]
         )  ? (
           <>
           <div
             className={
               "sidebarRow " +
               (pageDesplegado === "mantenimiento" ? "sideRowSelected" + mode : "")
             }
           >
             <div
               className={
                 "sidebarCont" +
                 mode +
                 " " +
                 (pageDesplegado === "mantenimiento" ? "sideSelected" + mode : "")
               }
               name="mantenimiento"
               onClick={handleSection}
             >
               <div className="imgSideCont" name="mantenimiento">
                 <img
                   src={
                     "/iconos/mantenimiento-blanco.png" 
                     
                   }
                   name="mantenimiento"
                 />
               </div>
               <div className="textSideCont " name="mantenimiento">
               {capitalizeFirstLetter(lang[languaje]['mantenimiento'])}
               </div>
             </div>
             <div className="contArrowSelected">
             <img
                   src={
                     "/iconos/"+((pageDesplegado === "mantenimiento")?"down-arrow-select.png":"up-arrow-select.png") 
                     
                   }
                   name="mantenimiento"
                 />
             </div>
             
           </div>
           { pageDesplegado === "mantenimiento" && <div className="sidebarRow desplegado">
           
           <div className="sidebarRowsub ">
           <div
               className={
                 "sidebarCont" +
                 mode +
                 " " +
                 (pageSelected === "mantto-excepciones" ? "sideSelected" + mode : "")
               }
               name="mantto-excepciones"
               onClick={handleSection}
             >
               
               <div className="textSideCont " name="mantto-excepciones" style={{fontSize:'var(--font-size-xSmall)',width:'90%',left: '10%',position: 'relative'}}>
               {capitalizeFirstLetter(lang[languaje]['exepciones'])}
               </div>
             </div>
           </div>
           <div className="sidebarRowsub ">
           <div
               className={
                 "sidebarCont" +
                 mode +
                 " " +
                 (pageSelected === "mantto-calendar" ? "sideSelected" + mode : "")
               }
               name="mantto-calendar"
               onClick={handleSection}
             >
               
               <div className="textSideCont " name="mantto-calendar" style={{fontSize:'var(--font-size-xSmall)',width:'90%',left: '10%',position: 'relative'}}>
               {capitalizeFirstLetter(lang[languaje]['manttoCalendar'])}
               </div>
             </div>
           </div>
          
         </div>}
           </>
         ) : (
           ""
         )}
         {/* {mantenimiento.value == 1  &&
         userPermissions.some(
           (objeto) =>
             objeto.permission_id === permisos_codigo_id["mantenimiento"]
         )  ? (
           <div
             className={
               "sidebarRow " +
               (pageSelected === "mantenimiento" ? "sideRowSelected" + mode : "")
             }
           >
             <div
               className={
                 "sidebarCont" +
                 mode +
                 " " +
                 (pageSelected === "mantenimiento" ? "sideSelected" + mode : "")
               }
               name="mantenimiento"
               onClick={handleSection}
             >
               <div className="imgSideCont" name="mantenimiento">
                 <img
                   src={
                     "/iconos/mantenimiento-blanco.png" 
                   }
                   name="mantenimiento"
                 />
               </div>
               <div className="textSideCont" name="mantenimiento">
               {capitalizeFirstLetter(lang[languaje]['mantenimiento'])}
               </div>
             </div>
           </div>
         ) : (
           ""
         )} */}
         {reportes.value == 1 &&
         userPermissions.some(
           (objeto) => objeto.permission_id === permisos_codigo_id["reportes"]
         ) ? (
           <>
           <div
             className={
               "sidebarRow " +
               (pageDesplegado === "reportes" ? "sideRowSelected" + mode : "")
             }
           >
             <div
               className={
                 "sidebarCont" +
                 mode +
                 " " +
                 (pageDesplegado === "reportes" ? "sideSelected" + mode : "")
               }
               name="reportes"
               onClick={handleSection}
             >
               <div className="imgSideCont" name="reportes">
                 <img
                   src={
                     "/iconos/reportes-blanco.png" 
                     
                   }
                   name="reportes"
                 />
               </div>
               <div className="textSideCont " name="reportes">
               {capitalizeFirstLetter(lang[languaje]['reportes'])}
               </div>
             </div>
             <div className="contArrowSelected">
             <img
                   src={
                     "/iconos/"+((pageDesplegado === "reportes")?"down-arrow-select.png":"up-arrow-select.png") 
                     
                   }
                   name="reportes"
                 />
             </div>
             
           </div>
           { pageDesplegado === "reportes" && <div className="sidebarRow desplegado">
           
           {/* <div className="sidebarRowsub ">
           <div
               className={
                 "sidebarCont" +
                 mode +
                 " " +
                 (pageSelected === "reporte-sla" ? "sideSelected" + mode : "")
               }
               name=""
               onClick={handleSection}
             >
               
               <div className="textSideCont " name="reporte-sla" style={{fontSize:'var(--font-size-xSmall)',width:'90%',left: '10%',position: 'relative'}}>
               {'SLA'}
               </div>
             </div>
           </div> */}
           <div className="sidebarRowsub ">
           <div
               className={
                 "sidebarCont" +
                 mode +
                 " " +
                 (pageSelected === "reporte-disp" ? "sideSelected" + mode : "")
               }
               name="reporte-disp"
               onClick={handleSection}
             >
               
               <div className="textSideCont " name="reporte-disp" style={{fontSize:'var(--font-size-xSmall)',width:'90%',left: '10%',position: 'relative'}}>
               {capitalizeFirstLetter(lang[languaje]['disponibilidad'])}
               </div>
             </div>
           </div>
          {/* historico eventos */}
          <div className="sidebarRowsub ">
           <div
               className={
                 "sidebarCont" +
                 mode +
                 " " +
                 (pageSelected === "reporte-eventos-historic" ? "sideSelected" + mode : "")
               }
               name="reporte-eventos-historic"
               onClick={handleSection}
             >
               
               <div className="textSideCont " name="reporte-eventos-historic" style={{fontSize:'var(--font-size-xSmall)',width:'90%',left: '10%',position: 'relative'}}>
               {capitalizeFirstLetter(lang[languaje]['historicoEvents'])}
               </div>
             </div>
           </div>
           {/* eventos vs tickets */}
           <div className="sidebarRowsub ">
           <div
               className={
                 "sidebarCont" +
                 mode +
                 " " +
                 (pageSelected === "reporte-eventos-tickets" ? "sideSelected" + mode : "")
               }
               name="reporte-eventos-tickets"
               onClick={handleSection}
             >
               
               <div className="textSideCont " name="reporte-eventos-tickets" style={{fontSize:'var(--font-size-xSmall)',width:'90%',left: '10%',position: 'relative'}}>
               {capitalizeFirstLetter(lang[languaje]['eventsTickets'])}
               </div>
             </div>
           </div>
           {/* reporte kpi */}
           <div className="sidebarRowsub ">
           <div
               className={
                 "sidebarCont" +
                 mode +
                 " " +
                 (pageSelected === "reporte-kpi" ? "sideSelected" + mode : "")
               }
               name="reporte-kpi"
               onClick={handleSection}
             >
               
               <div className="textSideCont " name="reporte-kpi" style={{fontSize:'var(--font-size-xSmall)',width:'90%',left: '10%',position: 'relative'}}>
               {capitalizeFirstLetter(lang[languaje]['reportes'])+" KPI´s"}
               </div>
             </div>
           </div>
           {/* reporte grafica kpi */}
           <div className="sidebarRowsub ">
           <div
               className={
                 "sidebarCont" +
                 mode +
                 " " +
                 (pageSelected === "reporte-graph-kpi" ? "sideSelected" + mode : "")
               }
               name="reporte-graph-kpi"
               onClick={handleSection}
             >
               
               <div className="textSideCont " name="reporte-graph-kpi" style={{fontSize:'var(--font-size-xSmall)',width:'90%',left: '10%',position: 'relative'}}>
               {capitalizeFirstLetter(lang[languaje]['grafica'])+" KPI´s"}
               </div>
             </div>
           </div>
           {/* reporte grafica metrica */}
           <div className="sidebarRowsub ">
           <div
               className={
                 "sidebarCont" +
                 mode +
                 " " +
                 (pageSelected === "reporte-graph-metrica" ? "sideSelected" + mode : "")
               }
               name="reporte-graph-metrica"
               onClick={handleSection}
             >
               
               <div className="textSideCont " name="reporte-graph-metrica" style={{fontSize:'var(--font-size-xSmall)',width:'90%',left: '10%',position: 'relative'}}>
               {capitalizeFirstLetter(lang[languaje]['grafica'])+" "+capitalizeFirstLetter(lang[languaje]['medicion'])}
               </div>
             </div>
           </div>
           {/* reporte bi */}
           <div className="sidebarRowsub ">
           <div
               className={
                 "sidebarCont" +
                 mode +
                 " " +
                 (pageSelected === "reporte-BI" ? "sideSelected" + mode : "")
               }
               name="reporte-BI"
               onClick={handleSection}
             >
               
               <div className="textSideCont " name="reporte-BI" style={{fontSize:'var(--font-size-xSmall)',width:'90%',left: '10%',position: 'relative'}}>
               {capitalizeFirstLetter(lang[languaje]['reportes'])+" BI"}
               </div>
             </div>
           </div>
         </div>}
           </>
         ) : (
           ""
         )}
         {acciones.value == 1 &&
         userPermissions.some(
           (objeto) => objeto.permission_id === permisos_codigo_id["acciones"]
         ) ? (
           <div
             className={
               "sidebarRow " +
               (pageSelected === "acciones" ? "sideRowSelected" + mode : "")
             }
           >
             <div
               className={
                 "sidebarCont" +
                 mode +
                 " " +
                 (pageSelected === "acciones" ? "sideSelected" + mode : "")
               }
               name="acciones"
               onClick={handleSection}
             >
               <div className="imgSideCont" name="acciones">
                 <img
                   src={
                     "/iconos/acciones-blanco.png" 
                   }
                   name="acciones"
                 />
               </div>
               <div className="textSideCont " name="acciones">
               {capitalizeFirstLetter(lang[languaje]['acciones'])}
               </div>
             </div>
           </div>
         ) : (
           ""
         )}
         {hosts == 1 ? (
           <div
             className={
               "sidebarRow " +
               (pageSelected === "host-manage" ? "sideRowSelected" + mode : "")
             }
           >
             <div
               className={
                 "sidebarCont" +
                 mode +
                 " " +
                 (pageSelected === "host-manage" ? "sideSelected" + mode : "")
               }
               name="host-manage"
               onClick={handleSection}
             >
               <div className="imgSideCont" name="host-manage">
                 <img
                   src={
                     "/iconos/host-manage-blanco.png" 
                   }
                   name="host-manage"
                 />
               </div>
               <div className="textSideCont " name="host-manage">
                 HOSTS
               </div>
             </div>
           </div>
         ) : (
           ""
         )}
         {buzon.value == 1 &&
         userPermissions.some(
           (objeto) => objeto.permission_id === permisos_codigo_id["buzon"]
         ) ? (
           <div
             className={
               "sidebarRow " +
               (pageSelected === "buzon" ? "sideRowSelected" + mode : "")
             }
           >
             <div
               className={
                 "sidebarCont" +
                 mode +
                 " " +
                 (pageSelected === "buzon" ? "sideSelected" + mode : "")
               }
               name="buzon"
               onClick={handleSection}
             >
               <div className="imgSideCont" name="buzon">
                 <img
                   src={
                     "/iconos/buzon-blanco.png" 
                     
                   }
                   name="buzon"
                 />
               </div>
               <div className="textSideCont " name="buzon">
               {capitalizeFirstLetter(lang[languaje]['buzon'])}
               </div>
             </div>
           </div>
         ) : (
           ""
         )}
         {/* ********************************************** */}
         {
         // buzon.value == 1 &&
         // userPermissions.some(
         //   (objeto) => objeto.permission_id === permisos_codigo_id["buzon"]
         // ) 
         true? (
           <>
           <div
             className={
               "sidebarRow " +
               (pageDesplegado === "respaldo" ? "sideRowSelected" + mode : "")
             }
           >
             <div
               className={
                 "sidebarCont" +
                 mode +
                 " " +
                 (pageDesplegado === "respaldo" ? "sideSelected" + mode : "")
               }
               name="respaldo"
               onClick={handleSection}
             >
               <div className="imgSideCont" name="respaldo">
                 <img
                   src={
                     "/iconos/respaldo-blanco.png" 
                     
                   }
                   name="respaldo"
                 />
               </div>
               <div className="textSideCont " name="respaldo">
               {capitalizeFirstLetter(lang[languaje]['respaldo'])}
               </div>
             </div>
             <div className="contArrowSelected">
             <img
                   src={
                     "/iconos/"+((pageDesplegado === "respaldo")?"down-arrow-select.png":"up-arrow-select.png") 
                     
                   }
                   name="respaldo"
                 />
             </div>
             
           </div>
           { pageDesplegado === "respaldo" && <div className="sidebarRow desplegado">
           
           <div className="sidebarRowsub ">
           <div
               className={
                 "sidebarCont" +
                 mode +
                 " " +
                 (pageSelected === "respaldo-config" ? "sideSelected" + mode : "")
               }
               name=""
               onClick={handleSection}
             >
               
               <div className="textSideCont " name="respaldo-config" style={{fontSize:'var(--font-size-xSmall)',width:'90%',left: '10%',position: 'relative'}}>
               {capitalizeFirstLetter(lang[languaje]['respaldoConfig'])}
               </div>
             </div>
           </div>
           {/* <div className="sidebarRowsub ">
           <div
               className={
                 "sidebarCont" +
                 mode +
                 " " +
                 (pageSelected === "respaldo-op" ? "sideSelected" + mode : "")
               }
               name="respaldo-op"
               onClick={handleSection}
             >
               
               <div className="textSideCont " name="respaldo-op" style={{fontSize:'var(--font-size-xSmall)',width:'90%',left: '10%',position: 'relative'}}>
               {capitalizeFirstLetter(lang[languaje]['respaldoOper'])}
               </div>
             </div>
           </div> */}
          
         </div>}
           </>
         ) : (
           ""
         )}
         {
         // buzon.value == 1 &&
         // userPermissions.some(
         //   (objeto) => objeto.permission_id === permisos_codigo_id["buzon"]
         // ) 
         true? (
           <>
           <div
             className={
               "sidebarRow " +
               (pageDesplegado === "encuestas" ? "sideRowSelected" + mode : "")
             }
           >
             <div
               className={
                 "sidebarCont" +
                 mode +
                 " " +
                 (pageDesplegado === "encuestas" ? "sideSelected" + mode : "")
               }
               name="encuestas"
               onClick={handleSection}
             >
               <div className="imgSideCont" name="respaencuestasdo">
                 <img
                   src={
                     "/iconos/encuestas-blanco.png" 
                     
                   }
                   name="encuestas"
                 />
               </div>
               <div className="textSideCont " name="encuestas">
               {capitalizeFirstLetter(lang[languaje]['encuestas'])}
               </div>
             </div>
             <div className="contArrowSelected">
             <img
                   src={
                     "/iconos/"+((pageDesplegado === "encuestas")?"down-arrow-select.png":"up-arrow-select.png") 
                     
                   }
                   name="respaldo"
                 />
             </div>
             
           </div>
           { pageDesplegado === "encuestas" && <div className="sidebarRow desplegado">
           
           <div className="sidebarRowsub ">
           <div
               className={
                 "sidebarCont" +
                 mode +
                 " " +
                 (pageSelected === "encuestas-gen" ? "sideSelected" + mode : "")
               }
               name="encuestas-gen"
               onClick={handleSection}
             >
               
               <div className="textSideCont " name="encuestas-gen" style={{fontSize:'var(--font-size-xSmall)',width:'90%',left: '10%',position: 'relative'}}>
               {capitalizeFirstLetter(lang[languaje]['encuestas'])}
               </div>
             </div>
           </div>
           <div className="sidebarRowsub ">
           <div
               className={
                 "sidebarCont" +
                 mode +
                 " " +
                 (pageSelected === "encuestas-res" ? "sideSelected" + mode : "")
               }
               name="encuestas-res"
               onClick={handleSection}
             >
               
               <div className="textSideCont " name="encuestas-res" style={{fontSize:'var(--font-size-xSmall)',width:'90%',left: '10%',position: 'relative'}}>
               {capitalizeFirstLetter(lang[languaje]['encuestasResultados'])}
               </div>
             </div>
           </div>
          
         </div>}
           </>
         ) : (
           ""
         )}
         {
         // buzon.value == 1 &&
         // userPermissions.some(
         //   (objeto) => objeto.permission_id === permisos_codigo_id["buzon"]
         // ) 
         true? (
           <>
           <div
             className={
               "sidebarRow " +
               (pageDesplegado === "workflow" ? "sideRowSelected" + mode : "")
             }
           >
             <div
               className={
                 "sidebarCont" +
                 mode +
                 " " +
                 (pageDesplegado === "workflow" ? "sideSelected" + mode : "")
               }
               name="workflow"
               onClick={handleSection}
             >
               <div className="imgSideCont" name="workflow">
                 <img
                   src={
                     "/iconos/workflow-blanco.png" 
                     
                   }
                   name="workflow"
                 />
               </div>
               <div className="textSideCont " name="workflow">
               {capitalizeFirstLetter(lang[languaje]['workflow'])}
               </div>
             </div>
             <div className="contArrowSelected">
             <img
                   src={
                     "/iconos/"+((pageDesplegado === "workflow")?"down-arrow-select.png":"up-arrow-select.png") 
                     
                   }
                   name="workflow"
                 />
             </div>
             
           </div>
           { pageDesplegado === "workflow" && <div className="sidebarRow desplegado">
           
           <div className="sidebarRowsub ">
           <div
               className={
                 "sidebarCont" +
                 mode +
                 " " +
                 (pageSelected === "workflow-gen" ? "sideSelected" + mode : "")
               }
               name="workflow-gen"
               onClick={handleSection}
             >
               
               <div className="textSideCont " name="workflow-gen" style={{fontSize:'var(--font-size-xSmall)',width:'90%',left: '10%',position: 'relative'}}>
               {capitalizeFirstLetter(lang[languaje]['workflow'])}
               </div>
             </div>
           </div>
           
           <div className="sidebarRowsub ">
           <div
               className={
                 "sidebarCont" +
                 mode +
                 " " +
                 (pageSelected === "workflow-action" ? "sideSelected" + mode : "")
               }
               name="workflow-action"
               onClick={handleSection}
             >
               
               <div className="textSideCont " name="workflow-action" style={{fontSize:'var(--font-size-xSmall)',width:'90%',left: '10%',position: 'relative'}}>
               {capitalizeFirstLetter(lang[languaje]['workflowAction'])}
               </div>
             </div>
           </div>
         </div>}
           </>
         ) : (
           ""
         )}

         {configuracion.value == 1 
         &&
         userPermissions.some(
           (objeto) => objeto.permission_id === permisos_codigo_id["configuracion"]
         ) 
         ? (<>
           <div
             className={
               "sidebarRow " +
               (pageDesplegado === "config" ? "sideRowSelected" + mode : "")
             }
           >
             <div
               className={
                 "sidebarCont" +
                 mode +
                 " " +
                 (pageDesplegado === "config" ? "sideSelected" + mode : "")
               }
               name="config"
               onClick={handleSection}
             >
               <div className="imgSideCont" name="config">
                 <img
                   src={
                     "/iconos/config-blanco.png" 
                     
                   }
                   name="config"
                 />
               </div>
               <div className="textSideCont " name="config" >
               {capitalizeFirstLetter(lang[languaje]['config'])}
               </div>
             </div>
             <div className="contArrowSelected">
             <img
                   src={
                     "/iconos/"+((pageDesplegado === "config")?"down-arrow-select.png":"up-arrow-select.png") 
                     
                   }
                   name="config"
                 />
             </div>
           </div>
          { pageDesplegado === "config" && <div className="sidebarRow desplegado">
           {/* agencias */}
           <div className="sidebarRowsub ">
           <div
               className={
                 "sidebarCont" +
                 mode +
                 " " +
                 (pageSelected === "config-agency" ? "sideSelected" + mode : "")
               }
               name="config-agency"
               onClick={handleSection}
             >
               
               <div className="textSideCont " name="config-agency" style={{fontSize:'var(--font-size-xSmall)',width:'90%',left: '10%',position: 'relative'}}>
               {capitalizeFirstLetter(lang[languaje]['agencias'])}
               </div>
             </div>
           </div>
           {/* criticidades */}
           <div className="sidebarRowsub ">
           <div
               className={
                 "sidebarCont" +
                 mode +
                 " " +
                 (pageSelected === "config-criticity" ? "sideSelected" + mode : "")
               }
               name="config-criticity"
               onClick={handleSection}
             >
               
               <div className="textSideCont " name="config-criticity" style={{fontSize:'var(--font-size-xSmall)',width:'90%',left: '10%',position: 'relative'}}>
               {capitalizeFirstLetter(lang[languaje]['criticidadDispositivo'])}
               </div>
             </div>
           </div>
           {/* grupos */}
           <div className="sidebarRowsub ">
           <div
               className={
                 "sidebarCont" +
                 mode +
                 " " +
                 (pageSelected === "config-grupos" ? "sideSelected" + mode : "")
               }
               name="config-grupos"
               onClick={handleSection}
             >
               
               <div className="textSideCont " name="config-grupos" style={{fontSize:'var(--font-size-xSmall)',width:'90%',left: '10%',position: 'relative'}}>
               {capitalizeFirstLetter(lang[languaje]['gruposDispositivos'])}
               </div>
             </div>
           </div>
           {/* proxies */}
           <div className="sidebarRowsub ">
           <div
               className={
                 "sidebarCont" +
                 mode +
                 " " +
                 (pageSelected === "config-proxies" ? "sideSelected" + mode : "")
               }
               name="config-proxies"
               onClick={handleSection}
             >
               
               <div className="textSideCont " name="config-proxies" style={{fontSize:'var(--font-size-xSmall)',width:'90%',left: '10%',position: 'relative'}}>
               {capitalizeFirstLetter(lang[languaje]['proxies'])}
               </div>
             </div>
           </div>
           {/* dispositivos */}
           <div className="sidebarRowsub ">
           <div
               className={
                 "sidebarCont" +
                 mode +
                 " " +
                 (pageSelected === "config-hosts" ? "sideSelected" + mode : "")
               }
               name="config-hosts"
               onClick={handleSection}
             >
               
               <div className="textSideCont " name="config-hosts" style={{fontSize:'var(--font-size-xSmall)',width:'90%',left: '10%',position: 'relative'}}>
               {capitalizeFirstLetter(lang[languaje]['dispositivos'])}
               </div>
             </div>
           </div>
           {/* tecnologias */}
           <div className="sidebarRowsub ">
           <div
               className={
                 "sidebarCont" +
                 mode +
                 " " +
                 (pageSelected === "config-tec" ? "sideSelected" + mode : "")
               }
               name="config-tec"
               onClick={handleSection}
             >
               
               <div className="textSideCont " name="config-tec" style={{fontSize:'var(--font-size-xSmall)',width:'90%',left: '10%',position: 'relative'}}>
               {capitalizeFirstLetter(lang[languaje]['tecnologias'])}
               </div>
             </div>
           </div>
           {/* marcas */}
           <div className="sidebarRowsub ">
           <div
               className={
                 "sidebarCont" +
                 mode +
                 " " +
                 (pageSelected === "config-brand" ? "sideSelected" + mode : "")
               }
               name="config-brand"
               onClick={handleSection}
             >
               
               <div className="textSideCont " name="config-brand" style={{fontSize:'var(--font-size-xSmall)',width:'90%',left: '10%',position: 'relative'}}>
               {capitalizeFirstLetter(lang[languaje]['marcas'])}
               </div>
             </div>
           </div>
           {/* modelos */}
           <div className="sidebarRowsub ">
           <div
               className={
                 "sidebarCont" +
                 mode +
                 " " +
                 (pageSelected === "config-models" ? "sideSelected" + mode : "")
               }
               name="config-models"
               onClick={handleSection}
             >
               
               <div className="textSideCont " name="config-models" style={{fontSize:'var(--font-size-xSmall)',width:'90%',left: '10%',position: 'relative'}}>
               {capitalizeFirstLetter(lang[languaje]['modelos'])}
               </div>
             </div>
           </div>
           {/* Mediciones */}
           <div className="sidebarRowsub ">
           <div
               className={
                 "sidebarCont" +
                 mode +
                 " " +
                 (pageSelected === "config-mediciones" ? "sideSelected" + mode : "")
               }
               name="config-mediciones"
               onClick={handleSection}
             >
               
               <div className="textSideCont " name="config-mediciones" style={{fontSize:'var(--font-size-xSmall)',width:'90%',left: '10%',position: 'relative'}}>
               {capitalizeFirstLetter(lang[languaje]['mediciones'])}
               </div>
             </div>
           </div>
           {/* disparadores */}
           <div className="sidebarRowsub ">
           <div
               className={
                 "sidebarCont" +
                 mode +
                 " " +
                 (pageSelected === "config-disparadores" ? "sideSelected" + mode : "")
               }
               name="config-disparadores"
               onClick={handleSection}
             >
               
               <div className="textSideCont " name="config-disparadores" style={{fontSize:'var(--font-size-xSmall)',width:'90%',left: '10%',position: 'relative'}}>
               {capitalizeFirstLetter(lang[languaje]['disparadores'])}
               </div>
             </div>
           </div>
           {/* eventos */}
           <div className="sidebarRowsub ">
           <div
               className={
                 "sidebarCont" +
                 mode +
                 " " +
                 (pageSelected === "config-eventos" ? "sideSelected" + mode : "")
               }
               name="config-eventos"
               onClick={handleSection}
             >
               
               <div className="textSideCont " name="config-eventos" style={{fontSize:'var(--font-size-xSmall)',width:'90%',left: '10%',position: 'relative'}}>
               {capitalizeFirstLetter(lang[languaje]['eventos'])}
               </div>
             </div>
           </div>
            
           {/* Medios Difusion */}
           <div className={"sidebarRowsub "+(subPageDesplegado === "config-medDif" ? "submodulos " + mode : "")} >
           <div
               className={
                 "sidebarCont" +
                 mode +
                 " " +
                 (pageSelected === "config-medDif" ? "sideSelected " + mode : "")
                 
                 
               }
               name="config-medDif"
               onClick={handleSection}
             >
               
               <div className="textSideCont " name="config-medDif" style={{fontSize:'var(--font-size-xSmall)',width:'90%',left: '10%',position: 'relative'}}>
               {capitalizeFirstLetter(lang[languaje]['mediosDifusion'])}
               </div>
               <div className="contArrowSelected">
             <img
                   src={
                     "/iconos/"+((subPageDesplegado === "config-medDif")?"down-arrow-select.png":"up-arrow-select.png") 
                     
                   }
                   name="config"
                 />
             </div>
             </div>
            
           </div>
           { subPageDesplegado=== "config-medDif" && <div className="sidebarRow desplegado submodulos">
               {/*  grupos telegram */}
           <div className="sidebarRowsub " >
           <div
               className={
                 "sidebarCont" +
                 mode +
                 " " +
                 (pageSelected === "config-telegram" ? "sideSelected" + mode : "")
               }
               name="config-telegram"
               onClick={handleSection}
             >
               
               <div className="textSideCont " name="config-telegram" style={{fontSize:'var(--font-size-xSmall)',width:'90%',left: '10%',position: 'relative'}}>
               {capitalizeFirstLetter(lang[languaje]['gruposTelegram'])}
               </div>
             </div>
           </div>
           {/*  plantillas telegram */}
           <div className="sidebarRowsub " >
           <div
               className={
                 "sidebarCont" +
                 mode +
                 " " +
                 (pageSelected === "config-platelegram" ? "sideSelected" + mode : "")
               }
               name="config-platelegram"
               onClick={handleSection}
             >
               
               <div className="textSideCont " name="config-platelegram" style={{fontSize:'var(--font-size-xSmall)',width:'90%',left: '10%',position: 'relative'}}>
               {capitalizeFirstLetter(lang[languaje]['plantillaTelegram'])}
               </div>
             </div>
           </div>
           {/*  Ultimas Lecturas Comandos Telegram */}
           <div className="sidebarRowsub " >
           <div
               className={
                 "sidebarCont" +
                 mode +
                 " " +
                 (pageSelected === "config-lastReadTele" ? "sideSelected" + mode : "")
               }
               name="config-lastReadTele"
               onClick={handleSection}
             >
               
               <div className="textSideCont " name="config-lastReadTele" style={{fontSize:'var(--font-size-xSmall)',width:'90%',left: '10%',position: 'relative'}}>
               {capitalizeFirstLetter(lang[languaje]['lastReadTele'])}
               </div>
             </div>
           </div>
               </div>}
           {/* Auditoria */}
           <div className="sidebarRowsub ">
           <div
               className={
                 "sidebarCont" +
                 mode +
                 " " +
                 (pageSelected === "config-audit" ? "sideSelected" + mode : "")
               }
               name="config-audit"
               onClick={handleSection}
             >
               
               <div className="textSideCont " name="config-audit" style={{fontSize:'var(--font-size-xSmall)',width:'90%',left: '10%',position: 'relative'}}>
               {capitalizeFirstLetter(lang[languaje]['auditor'])}
               </div>
             </div>
           </div>
         </div>}
           </>
         ) : (
           ""
         )}
          {
         // buzon.value == 1 &&
         // userPermissions.some(
         //   (objeto) => objeto.permission_id === permisos_codigo_id["buzon"]
         // ) 
         true? (
           <>
           <div
             className={
               "sidebarRow " +
               (pageDesplegado === "respaldo" ? "sideRowSelected" + mode : "")
             }
           >
             <div
               className={
                 "sidebarCont" +
                 mode +
                 " " +
                 (pageDesplegado === "respaldo" ? "sideSelected" + mode : "")
               }
               name="respaldo"
               onClick={handleSection}
             >
               <div className="imgSideCont" name="respaldo">
                 <img
                   src={
                     "/iconos/respaldo-blanco.png" 
                     
                   }
                   name="respaldo"
                 />
               </div>
               <div className="textSideCont " name="respaldo">
               {capitalizeFirstLetter(lang[languaje]['respaldo'])}
               </div>
             </div>
             <div className="contArrowSelected">
             <img
                   src={
                     "/iconos/"+((pageDesplegado === "respaldo")?"down-arrow-select.png":"up-arrow-select.png") 
                     
                   }
                   name="respaldo"
                 />
             </div>
             
           </div>
           { pageDesplegado === "respaldo" && <div className="sidebarRow desplegado">
           
           <div className="sidebarRowsub ">
           <div
               className={
                 "sidebarCont" +
                 mode +
                 " " +
                 (pageSelected === "respaldo-config" ? "sideSelected" + mode : "")
               }
               name=""
               onClick={handleSection}
             >
               
               <div className="textSideCont " name="respaldo-config" style={{fontSize:'var(--font-size-xSmall)',width:'90%',left: '10%',position: 'relative'}}>
               {capitalizeFirstLetter(lang[languaje]['respaldoConfig'])}
               </div>
             </div>
           </div>
           {/* <div className="sidebarRowsub ">
           <div
               className={
                 "sidebarCont" +
                 mode +
                 " " +
                 (pageSelected === "respaldo-op" ? "sideSelected" + mode : "")
               }
               name="respaldo-op"
               onClick={handleSection}
             >
               
               <div className="textSideCont " name="respaldo-op" style={{fontSize:'var(--font-size-xSmall)',width:'90%',left: '10%',position: 'relative'}}>
               {capitalizeFirstLetter(lang[languaje]['respaldoOper'])}
               </div>
             </div>
           </div> */}
          
         </div>}
           </>
         ) : (
           ""
         )}
         
       </>
     
       </div>
       <div className="sidebarFooter">
       <div className="sidebarRow" style={{height:'50%'}}>
           <div className={"sidebarCont" + mode} onClick={onLogin}>
             <div className="imgSideCont">
               <img src="/iconos/log-out-red.svg" />
             </div>
             <div className="textSideCont">{capitalizeFirstLetter(lang[languaje]['salir'])}</div>
           </div>
         </div>
         <div className="sideLogo"style={{height:'50%'}}>
          
           {/* <img
             src={
               "/escudos/" +
               (typeof estado.value === "undefined"
                 ? estado.value
                 : estado.value.toLowerCase().replaceAll(" ", "")) +
               ".svg"
             }
             className="icon-state"
             alt="Logo"
           /> */}
          
           <div
             className={"textSideCont txtEstado" + mode}
             style={{ textTransform: "capitalize" ,justifyContent:'center',}}
             name="estado"
           >
             {'V 1.3'}
           </div>
         </div>
       </div>
     </>
     )}
    </div>
  );
};

export default SideBar;
